import Button from './Button.svelte';
export * from './Button.types.js';
import GroupComponent from './Group.svelte';
export * from './Group.types.js';
const Group = GroupComponent;
import GroupItem from './GroupItem.js';
import { Label, Icon } from '@smui/common';
export default Button;
export { Group, GroupItem, Label, Icon };
//# sourceMappingURL=index.js.map